module.exports = __webpack_public_path__ + "static/img/dianshang1.b92dfc66.png";